// Lazy-load hero videos using IntersectionObserver
// Finds <video class="js-hero-video"> elements and sets <source>.src from data-src when visible.

function initHeroVideos() {
  if (!('IntersectionObserver' in window)) {
    // Fallback: load all sources immediately
    document.querySelectorAll('video.js-hero-video').forEach(video => {
      video.querySelectorAll('source[data-src]').forEach(s => { s.src = s.dataset.src; });
      try { video.load(); } catch (e) {}
    });
    return;
  }

  const videos = document.querySelectorAll('video.js-hero-video');
  if (!videos.length) return;

  const onIntersect = (entries, observer) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const video = entry.target;
      // populate sources
      video.querySelectorAll('source[data-src]').forEach(src => {
        src.src = src.dataset.src;
      });
      // load & attempt to play (muted should allow autoplay in most browsers)
      try {
        video.load();
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
      } catch (e) {}

      observer.unobserve(video);
    });
  };

  const io = new IntersectionObserver(onIntersect, {
    root: null,
    rootMargin: '200px 0px',
    threshold: 0.2
  });

  videos.forEach(v => {
    // Ensure the element won't start loading before JS runs
    // (preload="none" is set in markup)
    io.observe(v);
  });
}

// Initialize on DOMContentLoaded and also on turbolinks-like events if present
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroVideos);
} else {
  initHeroVideos();
}

export default initHeroVideos;
